import * as marietta3d from '../../../../marietta3d';
import * as THREE from "three";
import { TriggerType } from '../../base';
import { webcadDefines, View3dGlobal, ThreeView, ModelInfo, WebCadWalkThroughAnimation } from '..';
import { Loader } from './Loader';
import { attribute } from "../UtilityInfo";
import { OBBManager } from '../OBBManager';

export class FittingLoader {

    private _animationLoadingCount: number;

    constructor() {
        this._animationLoadingCount = 0;
    }

    /* setupFittings
    * 建具データのセットアップ.
    */
    public loadAsync(): Promise<void> {
        const modelList = this.FittingList();
        this._animationLoadingCount = modelList.length;

        if (this._animationLoadingCount <= 0) {
            return Promise.resolve();
        }

        return Promise.all(modelList.map((modelinfo) => {
            // const url = modelinfo.url;
            // return new Loader(url).getLoader().loadAsync(url).then((object) => {
            //     this.fittingLoadedNew(modelinfo, object, url);

            //     const PLOT_FITTING = false;
            //     if (PLOT_FITTING) {
            //         const group = new THREE.Group();
            //         this.setModelInfo(group, modelinfo);

            //         const lineOblect = (p1: THREE.Vector3, p2: THREE.Vector3, lineColor: THREE.Color): THREE.Object3D => {
            //             const material = new THREE.LineBasicMaterial({color: lineColor});
            //             const geometry = new THREE.BufferGeometry().setFromPoints( [p1, p2] );
            //             return new THREE.Line( geometry, material );
            //         }
            //         group.add(lineOblect(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 3, 0), new THREE.Color(0xff0000)));
            //         group.add(lineOblect(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 1), new THREE.Color(0x00ff00)));
            //         ThreeView.get().wcItemmgr.addOtherShapes(group);
            //     }
            // })
            // .catch((message) => {
            //     return Promise.reject();
            // });
            return this.load(modelinfo);
        })).then (() => {
            return Promise.resolve();
        });
    }

    private load(modelinfo: ModelInfo) {

        // const url = modelinfo.url;

        const url = modelinfo.url_model3d();
        const loader = new Loader(url).getLoader();

        this.debugplot(modelinfo);

        return loader.loadAsync(url).then((object) => {
            this.fittingLoade(modelinfo, object, url);
            ThreeView.get().wcItemmgr.fittings.push(<THREE.Group>(object.scene));
        })
        .catch((message) => {
            console.log(`not found modeldata - ${url}`);
            return Promise.resolve();
        });
    }

    private debugplot(modelinfo: ModelInfo) {
        const PLOT_FITTING = false;
        if (PLOT_FITTING) {
            const group = new THREE.Group();
            this.setModelInfo(group, modelinfo);

            const lineOblect = (p1: THREE.Vector3, p2: THREE.Vector3, lineColor: THREE.Color): THREE.Object3D => {
                const material = new THREE.LineBasicMaterial({color: lineColor});
                const geometry = new THREE.BufferGeometry().setFromPoints( [p1, p2] );
                return new THREE.Line( geometry, material );
            }
            group.add(lineOblect(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 3, 0), new THREE.Color(0xff0000)));
            group.add(lineOblect(new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, 1), new THREE.Color(0x00ff00)));
            ThreeView.get().wcItemmgr.addOtherShapes(group);
        }
    }

    /* getAnimationType
    * アニメーションタイプを判別.
    */
    private getAnimationType(obj: THREE.Object3D): TriggerType {
        return (obj.name.match(webcadDefines.AnimNames.autoNames)) ? TriggerType.standBefore : TriggerType.clickOn;
    }

    /* getTriggerDistance
    * アニメーションタイプを判別.
    */
    private getTriggerDistance(obj: THREE.Object3D): number {
        if (obj.name.match(/(^ent)/)) return webcadDefines.WebCadCameraDefs.wtAnimTriggerMaxDistEntryDoor;
        if (obj.name.match(/^(door)|^(toilet)|^(fusuma)|^(bath)/)) return webcadDefines.WebCadCameraDefs.wtAnimTriggerMaxDistInnerDoor;
        if (obj.name.match(/^(win)|^(sash)|^(shutter)/)) return webcadDefines.WebCadCameraDefs.wtAnimTriggerMaxDistWindow;
        return webcadDefines.WebCadCameraDefs.wtAnimTriggerMaxDist;
    }

    /* getFittingList
    * 読み込む建具のリストを作成.
    */
    private FittingList(): ModelInfo[] {
        console.log(View3dGlobal.shared.fitData);

        const items: any[] = [...View3dGlobal.shared.fitData, ...View3dGlobal.shared.decData];
        return items.filter((item) => item.isValid()).map((item) => item.setupURL3D());
    }

    private setModelInfo(object, modelinfo: ModelInfo) {

        object.scale.x *= modelinfo.scaleX;
        object.scale.y *= modelinfo.scaleY;
        object.scale.z *= modelinfo.scaleZ;
        object.translateX(modelinfo.translateX);
        object.translateY(modelinfo.translateY);
        object.translateZ(modelinfo.translateZ);
        object.rotateY(modelinfo.rotationY);
        object.rotateX(modelinfo.rotationX);
        object.updateMatrix();

        object.name = modelinfo.name;

        const plan: marietta3d.AutoGen.AutoBase = ThreeView.get().planmgr.autoData;

        const attribute_ = new attribute();
        attribute_.alternative = plan.alternative(modelinfo.code.substring(0,8));
        attribute_.thumbnail = modelinfo.thumbnail;
        attribute_.original_name = modelinfo.name;
        attribute_.colladaId = modelinfo.name;
        attribute_.objectId = modelinfo.code;

        const loader = new Loader(modelinfo.url);
        attribute_.objectName = `${modelinfo.code}.${loader.exitension()}`;

        object.userData.attribute = attribute_;
        object.userData.layer = modelinfo.layer;

        object.userData.modelInfo = modelinfo;
    }

    // fittingLoadedNew
    private fittingLoade(modelinfo: ModelInfo, object: any, url: string): void {
        const { matmgr } = ThreeView.get();
        object.scene.updateMatrixWorld(true);

        const newObj = object.scene;

        object.scene.userData.obb = new OBBManager(newObj);

        newObj.url = url;

        this.setModelInfo(newObj, modelinfo);

        matmgr.applyObjectMaterial(newObj, true);
        console.log(ThreeView.get().wcItemmgr.houseObjects);

        // ThreeView.get().wcItemmgr.houseObjects.add(newObj);
        ThreeView.get().wcItemmgr.registFloorObject(<THREE.Object3D>(newObj));
        ThreeView.get().wcItemmgr.animObjects.push(newObj);
        ThreeView.get().wcItemmgr.houseData.push(newObj);
        ThreeView.get().scene.add(<THREE.Group>newObj);

        // const pos = newObj.position;
        // newObj.localToWorld(pos);

        // if (object.animations && object.animations.length > 0) {
        //     const wtAnim = new WebCadWalkThroughAnimation(object, pos, this.getAnimationType(newObj));
        //     wtAnim.maxDist = this.getTriggerDistance(newObj);
        //     ThreeView.get().setAnimations(wtAnim);
        // }
    }
}

